export default class SelectFirmwareController {
    static get $inject() {
        return ['LanguageService', 'gettext', '$scope', 'EventHelperService', 'ApiPanelsService', 'toaster', '$uibModalInstance', 'panelId', 'notifiedEmailItem'];
    }

    constructor(LanguageService, gettext, $scope, EventHelperService, ApiPanelsService, toaster, $uibModalInstance, panelId, notifiedEmailItem) {
        this.LanguageService = LanguageService;
        this.gettext = gettext;
        this.$scope = $scope;
        this.EventHelperService = EventHelperService;
        this.ApiPanelsService = ApiPanelsService;
        this.toaster = toaster;
        this.uibModalInstance = $uibModalInstance;
        this.notifiedEmailItem = notifiedEmailItem;
        this.panelId = panelId;
        this.$scope.allEventsCids = this.EventHelperService.EVENTS_CIDS_TEXTS;
        this.notificationsFilterText = [this.gettext('alarm'), this.gettext('configuration'), this.gettext('information')
            , this.gettext('take_picture'), this.gettext('user_association'), this.gettext('arm'),
            this.gettext('troubles'), this.gettext('all')];
        this.receivePicturesText = this.gettext('receive_pictures');
        this.$scope.currentNotifiedEmailItem = {};
        this.notificationsFilter = {};
        this.receivePictures = {};
        this.notifyCids = [];

        if (this.notifiedEmailItem) {
            this.$scope.currentNotifiedEmailItem = angular.copy(this.notifiedEmailItem);
            this.emailId = this.$scope.currentNotifiedEmailItem.id;
            this.notifyCids = this.$scope.currentNotifiedEmailItem.notify_cids;
        } else {
            this.$scope.currentNotifiedEmailItem['notifications_filter'] = this.objectFlipAndReset(_.toPlainObject(this.notificationsFilterText));
            this.$scope.currentNotifiedEmailItem['notify_cids'] = this.notifyCids;
            this.$scope.currentNotifiedEmailItem['receive_pictures'] = false;
            this.$scope.currentNotifiedEmailItem['key'] = '';
        }
        this.$scope.eventsClick = (isChecked, cid) => {
            if (isChecked) {
                this.$scope.currentNotifiedEmailItem.notify_cids.push(_.toInteger(cid));
            }
            else {
                let index = _.indexOf(this.$scope.currentNotifiedEmailItem.notify_cids, _.toInteger(cid));
                this.$scope.currentNotifiedEmailItem.notify_cids.splice(index, 1);
            }
        };

        this.$scope.clearAll = () => {
            this.$scope.currentNotifiedEmailItem.notify_cids = [];
        };

        this.$scope.selectAll = () => {
            this.$scope.currentNotifiedEmailItem.notify_cids = this.setArrayOfStrToInt(_.keys(this.$scope.allEventsCids));
        };

        this.$scope.isFiltered = (cid) => {
            if (this.$scope.currentNotifiedEmailItem) {
                return _.indexOf(this.$scope.currentNotifiedEmailItem.notify_cids, _.toInteger(cid)) != -1;
            }
        };
    }

    submit() {
        this.ApiPanelsService.setSpecificEmailNotification(this.panelId, this.$scope.currentNotifiedEmailItem, this.emailId).then(() => {
            this.toaster.pop("success", this.LanguageService.getTranslatableText("Success"));
            this.onSubmitSuccess();
        }).catch(err => {
            this.onSubmitFail();
            this.toaster.pop("error", this.LanguageService.getTranslatableText("Error"));
        });
    }

    setArrayOfStrToInt(arrayOfStr) {
        return _.map(arrayOfStr, _.ary(parseInt, 1));
    }

    objectFlipAndReset(obj) {
        let ret = {};
        Object.keys(obj).forEach(key => {
            ret[obj[key]] = false;
        });
        return ret;
    }

    getTranslatableText(text) {
        return this.LanguageService.getTranslatableText(text);
    }

    perPageChanged() {
        this.currentPage = 1;
        this.getPage();
    }

    pageChanged() {
        this.getPage();
    }

    onSubmitSuccess() {
        this.uibModalInstance.close(this.$scope.currentNotifiedEmailItem);
    }

    onSubmitFail() {
        this.uibModalInstance.close();
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/configEmailNotification/controller.js
 **/